/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Instructor Service
 * This service is used to get instructor data
 * @file InstructorService.js
 * @author Mohamed yasar arabath M
 */

import Framework, { BaseService } from '@greenville/framework';
import { AET_STORE_EVENTS } from '../common/Constants';

export default class InstructorService extends BaseService {
  constructor() {
    super(AET_STORE_EVENTS.INSTRUCTOR_REQUESTED, 'instructorStatus');
    this.contextId = null;
  }

  /**
   * API call for Instructor data
   * @param {*} eventName
   * @param {*} eventData
   * @returns {Promise}
   */
  handleEvent(eventName, eventData = {}) {
    const { courseId } = eventData;
    // POST request to create an assignment
    return this.getClient('marin').get(`/aet/courses/${courseId}/instructors`);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse({ data }) {
    Framework.getEventManager().publish(AET_STORE_EVENTS.INSTRUCTOR_COMPLETED, data);
    Framework.getStoreRegistry().getStore('instructor').set(data);
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    Framework.getEventManager().publish(AET_STORE_EVENTS.INSTRUCTOR_FAILED, error);
  }
}
